import './scss/newsletter.scss'
import '../../../scss/_toast.scss'

import type { WidgetAppProps, WidgetProps } from "../../../types/widget.props.ts"
import { getResourceFromS3 } from "@/utils/getResourceFromS3.ts"
import { isDev } from "@/utils/enviroment-detector.ts"
import { useId } from "react"
import { Form } from "@/components/widget-especifico/components/Form.tsx"

export function Newsletter({ configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    const randomId = useId()

    return (
        <div className="container">
            <div className="widget-cadastro-news flex justify-center">
                <div className={`news-area news-form-${randomId} flex column align-center`}>
                    <span className="icon-mail item-center flex justify-center">
                        <img
                            className="lazyload lazyload-svg"
                            src={isDev() ? getResourceFromS3('assets/global/common-icons/newsletter', 'icon-email.svg') : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                            data-src={getResourceFromS3('assets/global/common-icons/newsletter', 'icon-email.svg')}
                            width={35}
                            height={26}
                            alt="Email Newsletter"
                            title="Email Newsletter"
                            draggable={false}
                        />
                    </span>

                    <h2 className="title">{textosPersonalizados.newsletterTitle}</h2>
                    <span className="sub-title">{textosPersonalizados.newsletterDescription}</span>

                    <Form
                        configuracaoSite={configuracaoSite}
                        textosPersonalizados={textosPersonalizados}
                        hasFieldTelefone
                        dinformname="newsletter-widget"
                        className={{
                            form: "flex",
                            button: "button"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default class WidgetNewsletterApp {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <Newsletter {...props} />
        )
    }
}